/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://qv23h1nnf7.execute-api.ap-southeast-1.amazonaws.com/testtwo",
            "region": "ap-southeast-1"
        },
        {
            "name": "commandApi",
            "endpoint": "https://0al38y4et9.execute-api.ap-southeast-1.amazonaws.com/testtwo",
            "region": "ap-southeast-1"
        },
        {
            "name": "sdautoApi",
            "endpoint": "https://k96b423wtc.execute-api.ap-southeast-1.amazonaws.com/testtwo",
            "region": "ap-southeast-1"
        },
        {
            "name": "stripeWebhook",
            "endpoint": "https://8rt7j5veqd.execute-api.ap-southeast-1.amazonaws.com/testtwo",
            "region": "ap-southeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://eg27rcj5rfdzbkhjbjfizhpdbq.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-zdhk5xoohfavpcumnkevm47kdu",
    "aws_cognito_identity_pool_id": "ap-southeast-1:797a8e1d-df82-4693-9ced-2472e72e702f",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_kJKM0mGIr",
    "aws_user_pools_web_client_id": "7fa18l1vs4jqeem2pdk78emnh2",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "badesk-storage94340-testtwo",
    "aws_user_files_s3_bucket_region": "ap-southeast-1"
};


export default awsmobile;
